module.exports = __webpack_public_path__ + "img/1544884307.0d7fdb4e.jpg";